export default "__VITE_ASSET__BMVbNuo7__"